import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from 'react'
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Collapse, Container, Modal, ModalBody, ModalFooter, Media, Label, Input, CardTitle, ModalHeader, Row, Spinner } from 'reactstrap'
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import Select from 'react-select';
import _valid from "../../validations"


const columns = [
    {
        label: "Codigo",
        field: "articulo_codigo",
        sort: "asc"
    },
    {
        label: "Nombre",
        field: "articulo_nombre",
        sort: "asc"
    },
    {
        label: "Descripcion",
        field: "articulo_descripcion",
        sort: "asc"
    },
    {
        label: "Serie",
        field: "articulo_serie",
        sort: "asc"
    },
    {
        label: "Fecha Ingreso",
        field: "articulo_fecha_creacion",
        sort: "asc"
    },
    {
        label: "Responsable",
        field: "colaborador_nombre",
        sort: "asc"
    },
    {
        label: "Departamento/area",
        field: "departamento_area_nombre",
        sort: "asc"
    },
    {
        label: "Ubicacion Area Trabajo",
        field: "area_trabajo_nombre",
        sort: "asc"
    },
    {
        label: "Estado",
        field: "estado",
        sort: "asc"
    },
    {
        label: "Cantidad",
        field: "cantidad",
        sort: "asc"
    },
    {
        label: "Costo Unitario",
        field: "articulo_costo",
        sort: "asc"
    },
    {
        label: "Valor",
        field: "valor",
        sort: "asc"
    }
];

export default class ReporteArticuloMaster extends React.Component {

    constructor(props) {
        super(props)

        this.apiRest = new ApiRest();

        switch (this.props.location.pathname) {
            case '/reporteArticuloMaster':
                this.titulo = 'Reporte Master de Activos';
                this.colapsar = true;
                break;
            case '/reporteArticuloUbicacion':
                this.titulo = 'Articulos por Ubicación';
                this.colapsar = false
                break;
        }

        this.state = {
            tabla: { columns: columns, rows: [] },
            modalAbierto: false,
            mostrarSpinner: true,
            mostrarTabla: false,
            filtro: {
                fecha_inicial: undefined,
                fecha_fin: undefined,
                estado: undefined,
                responsable: undefined,
                departamento: undefined,
                tipo_de_activo: undefined,
                nombre_activo: undefined,
                proveedor: undefined,
                codigo: undefined,
                empresa: undefined,
                tipo_cuenta: undefined,
                area_trabajo: undefined
            },
            departamentosAreas: [],
            listaProveedores: [],
            listaArticulos: [],
            listaTipoArticulo: [],
            listaCodigoArticulo: [],
            listaColaboradores: [],
            listaEmpresa: [],
            areasTrabajo: [],
            colapsarColaborador: this.colapsar
        }
        this.buscar = this.buscar.bind(this);
        this.actualizarValores = this.actualizarValores.bind(this);
        this.cambiosSolicitarD = this.cambiosSolicitarD.bind(this);
        this.cambiosSolicitarC = this.cambiosSolicitarC.bind(this);
        this.cambiosSolicitarA = this.cambiosSolicitarA.bind(this);
        this.cambiosSolicitarEmpresa = this.cambiosSolicitarEmpresa.bind(this);
        this.cambios = this.cambios.bind(this);
        this.borrarFiltros = this.borrarFiltros.bind(this);
    }

    componentDidMount() {
        this.cargarListado();
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            filtro: { ...estadoAnterior.filtro, [name]: value }
        }));
    }

    cambiosSolicitarD = (asignado) => {
        this.setState(estadoAnterior => ({
            filtro: { ...estadoAnterior.filtro, ['departamento']: asignado }
        }));
    }

    cambiosSolicitarC = (asignado) => {
        this.setState(estadoAnterior => ({
            filtro: { ...estadoAnterior.filtro, ['responsable']: asignado }
        }));
    }

    cambiosSolicitarA = (asignado) => {
        this.setState(estadoAnterior => ({
            filtro: { ...estadoAnterior.filtro, ['nombre_activo']: asignado }
        }));
    }

    cambios = (asignado) => {
        this.setState(estadoAnterior => ({
            filtro: { ...estadoAnterior.filtro, ['codigo']: asignado }
        }));
    }

    cambiosSolicitarP = (asignado) => {
        this.setState(estadoAnterior => ({
            filtro: { ...estadoAnterior.filtro, ['proveedor']: asignado }
        }));
    }

    cambiosSolicitarAT = (asignado) => {
        this.setState(estadoAnterior => ({
            filtro: { ...estadoAnterior.filtro, ['area_trabajo']: asignado }
        }));
    }

    cambiosSolicitarEmpresa = (asignado) => {
        this.setState(estadoAnterior => ({
            filtro: { ...estadoAnterior.filtro, ['empresa']: asignado }
        }));
        if(this.apiRest.getRol() == false){
            if(_valid(asignado)){
                this.apiRest.getColaborador('/getColaborador/',asignado.value).then(respuesta => {
                    if (respuesta.exitoso) {
                        this.setState({ listaColaboradores: this.formato(respuesta) });
                    }
                });
            }else{
                this.setState(estadoAnterior => ({
                    filtro: { ...estadoAnterior.filtro, ['responsable']: '' }
                }));
                this.setState({ listaColaboradores: undefined});
            }
        }
    }

    formatoSelect = valores => valores.data.map(i => ({ value: i.id, label: i.nombre }));
    formatoSelectArea = valores => valores.data.map(i => ({ value: i.id, label: i.texto_area }));
    formato = valores => valores.data.map(i => ({ value: i.id, label: i.nombres + " " + i.apellidos }));
    formatoCodigo = valores => valores.data.map(i => ({ value: i.id, label: i.codigo }));
    formatoEmpresa = valores => valores.map(i => ({ value: i.id, label: i.nombre }));

    cargarListado = () => {
        this.setState({ mostrarSpinner: true });
        /*if (this.apiRest.getRol()) {*/
            this.apiRest.get('/empresa').then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ mostrarSpinner: false, listaEmpresa: this.formatoSelect(resultado) });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        /*} else {
            let usuario = this.apiRest.getLS('du');
            this.setState({ mostrarSpinner: false, listaEmpresa: this.formatoEmpresa(usuario.usuario_empresas) });
        }*/
        this.apiRest.get('/departamentoArea').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ mostrarSpinner: false, departamentosAreas: this.formatoSelectArea(resultado) });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
        /*if (this.apiRest.getRol()) {*/
            this.apiRest.get('/colaborador').then(resultado => {
                if (resultado.exitoso) {

                    this.setState({ mostrarSpinner: false, listaColaboradores: this.formato(resultado) });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        /*}*/
        this.apiRest.get('/proveedor').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ mostrarSpinner: false, listaProveedores: this.formatoSelect(resultado) });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
        this.apiRest.get('/articulo').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ mostrarSpinner: false, listaArticulos: this.formatoSelect(resultado) });
                this.setState({ mostrarSpinner: false, listaCodigoArticulo: this.formatoCodigo(resultado) });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
        this.apiRest.get('/getAreaTrabajo').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ mostrarSpinner: false, areasTrabajo: this.formatoSelect(resultado) });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    filtrarDatos = async (filtro) => {
        let registro = this.crearFiltro(filtro);

        this.apiRest.post('/reporteArticulosMaster', registro).then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ mostrarTabla: true });
                this.setState({ mostrarSpinner: false, tabla: { columns, rows: respuesta.data } });
            } else {
                let v = [];
                this.setState({ mostrarSpinner: false, tabla: v.data });
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    crearFiltro = (e) => {

        let filtro = {
            fecha_inicial: _valid(e.fecha_inicial) == true ? e.fecha_inicial : undefined,
            fecha_fin: _valid(e.fecha_fin) == true ? e.fecha_fin : undefined,
            estado: _valid(e.estado) == true ? e.estado : undefined,
            responsable: _valid(e.responsable) == true ? e.responsable.value : undefined,
            departamento: _valid(e.departamento) == true ? e.departamento.value : undefined,
            tipo_de_activo: _valid(e.tipo_de_activo) == true ? e.tipo_de_activo : undefined,
            nombre_activo: _valid(e.nombre_activo) == true ? e.nombre_activo : undefined,
            proveedor: _valid(e.proveedor) == true ? e.proveedor.value : undefined,
            codigo: _valid(e.codigo) == true ? e.codigo : undefined,
            empresa: _valid(e.empresa) == true ? e.empresa.value : undefined,
            tipo_cuenta: _valid(e.tipo_cuenta) == true ? e.tipo_cuenta : undefined,
            area_trabajo: _valid(e.area_trabajo) == true ? e.area_trabajo.value : undefined
        }

        return filtro;
    }

    //reporte en excel
    reporte = (datos) => {
        const auth = this.apiRest.getLS('authUser');
        if (auth !== null) {
            const headers = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.access },
                responseType: 'blob',
                body: JSON.stringify(datos ? datos : '')
            }
            fetch(process.env.REACT_APP_API_URL + "/reporteArticulosMasterExcel", headers).then(resp => {
                if (resp.status >= 200 && resp.status < 300) {
                    resp.blob().then(blob => {
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.style.display = "none";
                        a.href = url;
                        // the filename you want
                        a.download = "Reporte_Activos_Master.xlsx";
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                    })
                } else if (resp.status === 401) {
                    this.props.history.push('/Timeout');
                }
            });
        } else {
            toastr.error('Vaya! No loggeado, por favor intenta nuevamente.');
        }
    }

    //dowload of excel 
    Reporte = async () => {
        const {
            tabla
        } = this.state
        let array = null;
        if (_valid(tabla)) {
            array = tabla.rows
        }

        if (_valid(array)) {
            this.reporte(array)
        } else {
            toastr.error('Busque Primero la Informacion que quiere Exportar a Excel');
        }
    }

    validador(filtro) {
        let verdad = false
        for (const property in filtro) {
            if (property == 'empresa') {
                if (this.apiRest.getRol()) {
                    verdad = true;
                } else {
                    if (_valid(filtro[property])) {
                        verdad = true
                    } else {
                        toastr.error('Debe seleccionar una empresa para realizar la Busqueda');
                    }
                }
            }
        }
        return verdad;
    }

    buscar = async () => {
        const {
            filtro
        } = this.state

        /*if (this.validador(filtro)) {*/
            this.filtrarDatos(filtro);
        /*} else {
            toastr.error('Seleccione un filtro para buscar por favor');
            let v = []
            this.setState({ mostrarSpinner: false, tabla: v.data });
        }*/
    }

    borrarFiltros = () => {

        const {
            filtro
        } = this.state

        for (const property in filtro) {
            this.borrarEstado(property)
        }
    }

    borrarEstado(name) {
        this.setState(estadoAnterior => ({
            filtro: {
                ...estadoAnterior.filtro, [name]: ''
            }
        }));
    }

    colapsarTablaAsociaciones = estadoAColapsar => {
        this.setState(estadoAnterior => ({ ...estadoAnterior, [estadoAColapsar]: !estadoAnterior[estadoAColapsar] }));
        this.borrarFiltros()
    }

    render() {
        const {
            mostrarSpinner,
            filtro,
            departamentosAreas,
            listaColaboradores,
            listaProveedores,
            listaEmpresa,
            areasTrabajo,
            colapsarColaborador
        } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Activos" breadcrumbItem={this.titulo} />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardTitle className="mb-4">Reporte de Activos</CardTitle>
                                    <CardBody>
                                        <Row> 
                                            <Col lg={12}>
                                                <Label htmlFor="departamento" className="form-label">
                                                    Departamento/Area
                                                </Label>
                                                <Select
                                                    name="departamento"
                                                    options={departamentosAreas}
                                                    value={filtro.departamento}
                                                    onChange={this.cambiosSolicitarD}
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    placeholder="Selecciona.."
                                                    isClearable={true}
                                                    isSearchable={true}
                                                    noOptionsMessage={() => "No hay más opciones"}
                                                />
                                            </Col>                     
                                        </Row>
                                        <p />
                                        <Collapse isOpen={colapsarColaborador}>
                                            <div>
                                            <Row>
                                                <Col lg={4}>
                                                    <Label htmlFor="area_trabajo" className="form-label">
                                                        Ubicaci&oacute;n Area Trabajo
                                                    </Label>
                                                    <Select
                                                        name="area_trabajo"
                                                        options={areasTrabajo}
                                                        value={filtro.area_trabajo}
                                                        onChange={this.cambiosSolicitarAT}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="Selecciona.."
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        noOptionsMessage={() => "No hay más opciones"}
                                                    />
                                                </Col>
                                                <Col lg={4}>
                                                    <Label htmlFor="responsable" className="form-label">
                                                        Responsable
                                                    </Label>
                                                    <Select
                                                        name="responsable"
                                                        options={listaColaboradores}
                                                        value={filtro.responsable}
                                                        onChange={this.cambiosSolicitarC}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="Selecciona.."
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        noOptionsMessage={() => "No hay más opciones"}
                                                    />
                                                </Col> 
                                                <Col lg={4}>
                                                    <Label htmlFor="fecha_inicial" className="form-label">
                                                        Fecha Inicio de Asignaci&oacute;n
                                                    </Label>
                                                    <Input
                                                        name="fecha_inicial"
                                                        value={filtro.fecha_inicial || ''}
                                                        onChange={this.actualizarValores}
                                                        type="date"
                                                    />
                                                </Col>
                                            </Row>
                                            <p />
                                            <Row>
                                                <Col lg={4}>
                                                    <Label htmlFor="fecha_fin" className="form-label">
                                                        Fecha Fin de Asignaci&oacute;n
                                                    </Label>
                                                    <Input
                                                        name="fecha_fin"
                                                        value={filtro.fecha_fin || ''}
                                                        onChange={this.actualizarValores}
                                                        type="date"
                                                    />
                                                </Col>
                                                <Col lg={4}>
                                                    <Label htmlFor="estado" className="form-label">
                                                        Estado
                                                    </Label>
                                                    <select
                                                        value={filtro.estado}
                                                        onChange={this.actualizarValores}
                                                        name="estado"
                                                        className="form-control"
                                                    >
                                                        <option value="">Selecciona..</option>
                                                        <option value="0">Baja</option>
                                                        <option value="1">Traslado</option>
                                                        <option value="2">Venta</option>
                                                        <option value="3">Inventario</option>
                                                        <option value="4">Otro</option>
                                                        <option value="5">Entregado</option>
                                                        <option value="7">Aceptado</option>
                                                        <option value="8">Parcialmente Aceptado</option>
                                                        <option value="9">No Aceptado</option>
                                                    </select>
                                                </Col>
                                            
                                                <Col lg={4}>
                                                    <Label htmlFor="proveedor" className="form-label">
                                                        Proveedor
                                                    </Label>
                                                    <Select
                                                        name="proveedor"
                                                        options={listaProveedores}
                                                        value={filtro.proveedor}
                                                        onChange={this.cambiosSolicitarP}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="Selecciona.."
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        noOptionsMessage={() => "No hay más opciones"}
                                                    />
                                                </Col>
                                            </Row>
                                            <p />
                                            <Row>
                                                <Col lg={4}>
                                                    <Label htmlFor="tipo_cuenta" className="form-label">
                                                        Tipo de Cuenta
                                                    </Label>
                                                    <Input
                                                        name="tipo_cuenta"
                                                        value={filtro.tipo_cuenta}
                                                        onChange={this.actualizarValores}
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Ingresa el tipo de Cuenta"
                                                    />
                                                </Col>
                                                <Col lg={4}>
                                                    <Label htmlFor="tipo_de_activo" className="form-label">
                                                        Tipo de Activo
                                                    </Label>
                                                    <select
                                                        value={filtro.tipo_de_activo}
                                                        onChange={this.actualizarValores}
                                                        name="tipo_de_activo"
                                                        className="form-control"
                                                    >
                                                        <option value="0">Selecciona...</option>
                                                        <option value="1">Fijo</option>
                                                        <option value="2">Funjible</option>
                                                        <option value="3">Inventariable</option>
                                                    </select>
                                                </Col>
                                                <Col lg={4}>
                                                    <Label htmlFor="nombre_activo" className="form-label">
                                                        Nombre Activo
                                                    </Label>
                                                    <Input
                                                        name="nombre_activo"
                                                        value={filtro.nombre_activo}
                                                        onChange={this.actualizarValores}
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Ingresa el nombre del activo"
                                                    />
                                                </Col>
                                            </Row>
                                            <p />
                                            <Row>
                                                <Col lg={4}>
                                                    <Label htmlFor="codigo" className="form-label">
                                                        C&oacute;digo Activo
                                                    </Label>
                                                    <Input
                                                        name="codigo"
                                                        value={filtro.codigo}
                                                        onChange={this.actualizarValores}
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Ingresa el código del activo"
                                                    />
                                                </Col>
                                                {
                                                _valid(listaEmpresa) ?
                                                    <Col lg={4}>
                                                        <Label htmlFor="empresa" className="form-label">
                                                            Empresa
                                                        </Label>
                                                        <Select
                                                            name="empresa"
                                                            options={listaEmpresa}
                                                            value={filtro.empresa}
                                                            onChange={this.cambiosSolicitarEmpresa}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            placeholder="Selecciona.."
                                                            isClearable={true}
                                                            isSearchable={true}
                                                            noOptionsMessage={() => "No hay más opciones"}
                                                        />
                                                    </Col>
                                                    :
                                                    <Col lg={4}>
                                                        <Label htmlFor="empresa" className="form-label">
                                                            EL USUARIO NO TIENE ASOCIADO UNA EMPRESA
                                                        </Label>
                                                    </Col>
                                                }
                                            </Row>
                                            </div>
                                        </Collapse>
                                        <p />
                                        <Row>
                                            <Col>
                                                <MDBBtn color="primary" onClick={this.buscar}>
                                                    <MDBIcon icon="fas fa-search" />{' '}
                                                    Buscar
                                                </MDBBtn>
                                                {' '}
                                                <MDBBtn color="success" onClick={this.Reporte}>
                                                    <MDBIcon icon="fas fa-book" />{' '}
                                                    Generar Reporte en Excel
                                                </MDBBtn>
                                                {' '}
                                                <MDBBtn className="waves-effect" color="warning" onClick={this.borrarFiltros}>
                                                    <MDBIcon icon="fas fa-trash-alt" />{' '}
                                                    Borrar Filtros
                                                </MDBBtn>
                                            </Col>
                                        </Row>
                                        <p />
                                        {
                                            mostrarSpinner &&
                                            <Row>
                                                <Col style={{ display: "flex", justifyContent: "center" }}>
                                                    <Spinner className="m-1" color="primary" />
                                                </Col>
                                            </Row>
                                        }
                                        <div className="p-4 border-top">
                                            <Row>
                                                <Col lg={12}>
                                                    <div className="table-responsive">
                                                        <MDBDataTable hover searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="Mostrando entradas" data={this.state.tabla} />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12} className="text-end">
                                <MDBBtn color="danger" onClick={() => { this.props.history.replace('/dashboard') }}>
                                    <MDBIcon icon="fas fa-arrow-left" />{' '}
                                    Regresar
                                </MDBBtn>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}